import { Col, Row, Button } from 'antd';
import i18next from 'i18next';
import React from 'react';
import { Trans } from 'react-i18next';
import { generatePath, useNavigate } from 'react-router';
export const CategorieList = ({
  categories = [],
  subsection = null,
  category = {},
  match,
  group
}) => {
  const goTo = useNavigate();
  const getCols = () => {
    if (categories.length === 1) {
      return { xs: 24 };
    } else if (categories.length === 2) {
      return { xs: 24, sm: 12 };
    } else {
      return { xs: 24, sm: 12, md: 8 };
    }
  }
  return <div className="risk-categories-list">
    <h3 className="title-semibold-3 text-center">
      {subsection ? <Trans i18nKey="riskCategoryTitle">
        Please choose one of the {{ categoryName: category.label }} sub categories
      </Trans> : i18next.t("Please choose one of the risk categories")}:</h3>
    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>{categories.map(c =>
      <Col className="gutter-row" {...getCols()}>
        <Button disabled={c.disabled} className="risk-categories" key={c.value} onClick={() => {
          const params = { ...match.params, group };
          if (subsection) {
            params.subsection = subsection;
            params.subgroup = c.value;
          } else {
            params.subsection = c.value;
          }
          goTo(generatePath(match.path, params))
        }}>{c.label}</Button>
      </Col>
    )}</Row>
  </div>
}
